export enum ParameterStatusType {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  UNSET = 'unset',
  NOT_ANALYZABLE = 'notAnalyzable',
}
